<script lang="ts">
  import type { Snippet } from "svelte";
  import { routeHref } from "@/router";

  type AdminSection = "overview" | "stats" | "payments" | "users" | "servers" | "nodes";
  interface Props {
    section: AdminSection;
    children: Snippet;
  }
  const { section, children }: Props = $props();
</script>

<section class="dashboard-intro admin-intro">
  <div>
    <p class="eyebrow">Mars Host / Операторская панель</p>
    <h1>
      {section === "overview"
        ? "Пульт"
        : section === "stats"
          ? "Статистика"
          : section === "payments"
            ? "Платежи"
            : section === "users"
              ? "Пользователи"
              : section === "servers"
                ? "Серверы"
                : "Ноды"} <em>марса</em>
    </h1>
    <p class="intro-copy">Операционная консоль инфраструктуры и аккаунтов.</p>
  </div>
</section>

<nav class="admin-subnav" aria-label="Разделы операторской панели">
  <a
    class:active={section === "overview"}
    aria-current={section === "overview" ? "page" : undefined}
    href={routeHref("admin-overview")}>Обзор</a
  >
  <a
    class:active={section === "stats"}
    aria-current={section === "stats" ? "page" : undefined}
    href={routeHref("admin-stats")}>Статистика</a
  >
  <a
    class:active={section === "payments"}
    aria-current={section === "payments" ? "page" : undefined}
    href={routeHref("admin-payments")}>Платежи</a
  >
  <a
    class:active={section === "users"}
    aria-current={section === "users" ? "page" : undefined}
    href={routeHref("admin-users")}>Пользователи</a
  >
  <a
    class:active={section === "servers"}
    aria-current={section === "servers" ? "page" : undefined}
    href={routeHref("admin-servers")}>Серверы</a
  >
  <a
    class:active={section === "nodes"}
    aria-current={section === "nodes" ? "page" : undefined}
    href={routeHref("admin-nodes")}>Ноды</a
  >
</nav>

{@render children()}
